import React, { useEffect, useRef, useState } from "react";
import FinalMolGrid from "../../components/FinalMolGrid/FinalMolGrid";
import Buttons from "../../components/ui/button/Buttons";
import { paginationObj } from "../../utils/Constants";
import { EventGalleryListConfig } from "./data/EventGalleryListConfig";
import Label from "../../components/forms/ui/label/Label";
import Input from "../../components/forms/ui/inputs/input/Input";
import { useDeleteEventGalleryMutation, useGetEventGallariesListMutation } from "../../app/services/EventGallery/EventGalleryApi";
import { useNavigate } from "react-router-dom";
import SwalAlert from "../../services/swalService/SwalService";
import DataLoader from "../../components/FinalMolGrid/ui/dataLoader/DataLoader";
import { getAuditContext } from "../../lib/authenticationLibrary";


const EventGalleryList = () => {
    const molGridRef = useRef();
    const { confirm, success, error } = SwalAlert();
    const audit = getAuditContext();
    const [dataSource, setDataSource] = useState();
    const [pagination, setPagination] = useState({
        ...paginationObj,
    });
    const navigate = useNavigate();
    // API Calls
    const [getEventGallariesList, { isLoading: eventGalleriesIsLoading, data: getEventGalleriesData, isSuccess: eventGalleriesIsSuccess }] = useGetEventGallariesListMutation();
    const [deleteEventGalleryById, { isSuccess: isSuccessEventGallery, data: deleteEventGalleryResponse }] = useDeleteEventGalleryMutation();

    // useEffects
    useEffect(() => {
        if (!eventGalleriesIsLoading && getEventGalleriesData && eventGalleriesIsSuccess) {
            setDataSource(getEventGalleriesData.itemList)
            setPagination(prev => {
                return { ...prev, totalCount: getEventGalleriesData.totalCount }
            });
        }
    }, [eventGalleriesIsLoading, getEventGalleriesData, eventGalleriesIsSuccess]);


    useEffect(() => {
        getEventGallariesData(pagination);
    }, []);

    useEffect(() => {
        if (isSuccessEventGallery && deleteEventGalleryResponse) {
            if (deleteEventGalleryResponse.hasError === false) {
                success("Event Deleted Successfully");
                getEventGallariesList(pagination);
            }
            else {
                error(deleteEventGalleryResponse.errorMessage)
            }
        }
    }, [isSuccessEventGallery, deleteEventGalleryResponse]);

    const handlePageChange = (page) => {
        const { pageNumber, pageSize } = page;
        getEventGallariesData({ ...pagination, pageSize: pageSize, pageNo: pageNumber })
    };
    // Functions
    const getEventGallariesData = (data) => {
        getEventGallariesList(data);
    }
    const addNew = () => {
        navigate('/manageEventGallery')
    }

    const handleInputChange = (e) => {
        let temp = { ...pagination }
        temp["SearchText"] = e
        setPagination(temp)
        getEventGallariesList(temp);
    }

    const handleEditClick = (data) => {
        navigate(`/editmanageEventGallery/${data.galleryEventId}`);
    }

    const handleDelete = (data) => {
        confirm('Delete', "Are you sure you want to delete", 'Yes', 'Cancel')
            .then(value => {
                if (value) {
                    const request = {
                        id: data.galleryEventId,
                        deletedBy: audit.adminUserId,
                        appId: audit.appId
                    }
                    deleteEventGalleryById(request)
                }
            })
    }
    const actionHandler = {
        EDIT: handleEditClick,
        DELETE: handleDelete
    };

    return (
        <div>
            <div className="membership-application">
                <div className="form-card">
                    <div className="row justify-content-between">
                        <div className="col-lg-6">
                            <Buttons
                                onClick={addNew}
                                buttonText={"+ Add New"}
                                buttonTypeClassName="theme-btn btn mt-auto"
                                isLoading={false}
                            />
                        </div>
                        <div className="col-lg-6">
                            <div className='d-flex gap-2 align-items-center justify-content-end'>
                                <div>
                                    <Label labelName="Search:" />
                                </div>
                                <div>
                                    <Input
                                        id="searchText"
                                        name='SearchText'
                                        value={pagination.SearchText}
                                        onChange={handleInputChange}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="table-100 mt-4">
                        <h5 className="align-self-end mb-1">Total Count: {getEventGalleriesData?.totalCount || 0}</h5>
                        {dataSource ?
                            <FinalMolGrid
                                ref={molGridRef}
                                configuration={EventGalleryListConfig}
                                dataSource={dataSource}
                                isLoading={eventGalleriesIsLoading}
                                allowPagination={true}
                                pagination={pagination}
                                onActionChange={actionHandler}
                                onPageChange={handlePageChange}
                            />
                            : <DataLoader />
                        }

                    </div>
                </div>
            </div>
        </div>
    );
};

export default EventGalleryList;
